import CreateAiAssignmentDesignerView from "@features/tools/view/ai-assignment-designer/create-ai-assignment-designer";

const CreateAiAssignmentDesigner = () => {
  return <CreateAiAssignmentDesignerView />;
};

export default CreateAiAssignmentDesigner;
